var protocolRegex = /(^\w+:|^)/g;
var queryRegex = /\?(.*)/g;
function trimAssetUrl(url) {
    return url === null || url === void 0 ? void 0 : url.replace(protocolRegex, '').replace(queryRegex, '');
}
export default trimAssetUrl;
//# sourceMappingURL=trimAssetUrl.js.map